export function formatDurationMs(ms: number): string {
  if (!Number.isFinite(ms)) return '—';
  const totalMs = Math.max(0, Math.round(ms));
  const minutes = Math.floor(totalMs / 60_000);
  const seconds = (totalMs % 60_000) / 1000;
  if (minutes > 0) {
    return `${minutes}:${seconds.toFixed(2).padStart(5, '0')}`;
  }
  return seconds.toFixed(2);
}

export function formatErrorMs(errorMs: number): string {
  if (!Number.isFinite(errorMs)) return 'FALSE START';
  return `±${Math.round(errorMs)}ms`;
}

/** Signed offset in seconds ("+0.07s" / "-0.33s") — early vs late, not just magnitude. Used by the result-badge reveal chips. */
export function formatSignedOffsetMs(elapsedMs: number, targetMs: number): string {
  const offsetSeconds = (elapsedMs - targetMs) / 1000;
  const sign = offsetSeconds >= 0 ? '+' : '-';
  return `${sign}${Math.abs(offsetSeconds).toFixed(2)}s`;
}

const HTML_ESCAPES: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

/**
 * Escapes a string for interpolation into an HTML template literal. Usernames
 * are charset-constrained at registration today, but every place user-supplied
 * text lands in `innerHTML` must escape regardless — the day that pattern is
 * relaxed, an unescaped sink becomes stored XSS.
 */
export function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (c) => HTML_ESCAPES[c]);
}
